// extracted by mini-css-extract-plugin
module.exports = {"menu":"statementLayout_menu__NA4iZ","title":"statementLayout_title__3Q1i7"};